import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import { setMetadataFormat } from '../../../store/actions/metadata.actions';

const formats = ['', 'EMAIL', 'URL','PARAGON FILE BREAKER'];

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: (48 * 4.5) + 8,
      width: 250,
    },
  },
};

const styles = () => ({
  formControl: {
    minWidth: 120,
  },
});

class RuleFormatContainer extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.renderSelectOptions = this.renderSelectOptions.bind(this);
  }

  handleChange(event) {
    this.props.setMetadataFormat(this.props.column.key, event.target.value);
  }

  // eslint-disable-next-line class-methods-use-this
  renderSelectOptions() {
    return formats.map(option => (
      <MenuItem
        key={option}
        value={option}
      >
        {option}
      </MenuItem>
    ));
  }

  render() {
    const { classes, column } = this.props;
    return (
      <FormControl className={classes.formControl}>
        <Select
          onChange={e => this.handleChange(e)}
          MenuProps={MenuProps}
          value={column.format}
          disabled={column.type === 'Skip'}
        >
          {this.renderSelectOptions()}
        </Select>
      </FormControl>
    );
  }
}

RuleFormatContainer.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    format: PropTypes.string,
  }).isRequired,
  setMetadataFormat: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(
  null,
  { setMetadataFormat },
)(RuleFormatContainer));
